// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-layout{display:flex;justify-content:center;align-items:center;min-height:100vh}
`, "",{"version":3,"sources":["webpack://./src/components/LoginPage/index.scss"],"names":[],"mappings":"AAAA,cACI,YAAa,CACb,sBAAuB,CACvB,kBAAmB,CACnB,gBAAiB","sourcesContent":[".login-layout {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
